import EmptyState from '@/app/(main)/_components/empty-state/empty-state';

export default function ProfessionalNotFound() {
  return (
    <EmptyState
      title="Profissional não encontrado"
      description="Este profissional não está disponível em nossa plataforma. Confira outras opções disponíveis:"
      button={{
        label: 'Ver profissionais',
        href: '/profissionais/',
      }}
    />
  );
}
